module.exports = __webpack_public_path__ + "img/MFT白皮书_54.24bfa2fa.jpg";